// DRTCS TRAINING FRAMEWORK — competency levels, tiers, and the full 6-module
// framework (modules → categories → items). Lifted VERBATIM from
// dros-beta-prototype_524.html (lines 4773–5272). Source of truth for Training.
/* eslint-disable */
// @ts-nocheck

export const DRTCS_LEVEL_MODEL = [
  { id:'L1', name:'Exposure',   tenure:'0–6 mo',   short:'Exp.',    def:'Has watched or shadowed the task. Knows the vocabulary. Cannot perform unsupervised.' },
  { id:'L2', name:'Competency', tenure:'6–18 mo',  short:'Comp.',   def:'Can perform safely and to code with direct supervision. Quality/speed still developing.' },
  { id:'L3', name:'Mastery',    tenure:'18–36 mo', short:'Mastery', def:'Performs at production speed and quality unsupervised. Meets Diamond Standard.' },
  { id:'L4', name:'Foreman',    tenure:'3–5 yr',   short:'Foreman', def:'Runs a crew, sequences work, owns QC and safety on assigned scope. Reads plans fluently.' },
  { id:'L5', name:'Trainer',    tenure:'5+ yr',    short:'Trainer', def:'Has trained others to L3+. Develops talent. Eligible for GM / Superintendent track.' },
];
export const DRTCS_LEVEL_VALUE = { L1:1, L2:2, L3:3, L4:4, L5:5 };
export const DRTCS_LEVELS_ORDER = ['L1','L2','L3','L4','L5'];

// DR Tier minimum bars by pillar (per-pillar average level). Omitted pillar = not required for that tier.
// Default tier bars: reaching Tier N requires an average Level N in every module
// (Tier 1 → L1 across the board, Tier 2 → L2, … Tier 5 → L5). Admins can tune these
// per-module on the Training → Tiers tab.
export const DRTCS_TIERS = [
  { id:'t1', label:'Tier 1 — Trade Helper',      bar:{ conduct:1, safety:1, projdisc:1, digital:1, trade:1, leadership:1 }, authorizedFor:'Maintenance / low-risk support work only' },
  { id:'t2', label:'Tier 2 — Trade Apprentice',  bar:{ conduct:2, safety:2, projdisc:2, digital:2, trade:2, leadership:2 }, authorizedFor:'Standard project work with crew supervision' },
  { id:'t3', label:'Tier 3 — Trade Journeyman',  bar:{ conduct:3, safety:3, projdisc:3, digital:3, trade:3, leadership:3 }, authorizedFor:'Full project deployment, eligible for Foreman track' },
  { id:'t4', label:'Tier 4 — Foreman Candidate', bar:{ conduct:4, safety:4, projdisc:4, digital:4, trade:4, leadership:4 }, authorizedFor:'Crew leadership' },
  { id:'t5', label:'Tier 5 — Trainer / Lead',    bar:{ conduct:5, safety:5, projdisc:5, digital:5, trade:5, leadership:5 }, authorizedFor:'Develops talent; GM / Superintendent track' },
];


export const DRTCS_FRAMEWORK = [
  { id: 'conduct', short: 'Conduct', name: 'Diamond Standard Conduct',
    description: 'Diamond Standard Conduct is the cultural foundation. Every employee — regardless of trade or tier — must demonstrate these behaviors. Mark \'X\' in the highest level achieved for each row. L3 (Mastery) is the minimum bar for any DR jobsite assignment beyond Tier 1.',
    categories: [
      { id: 'conduct-c1', name: 'Professional Presence', items: [
        { id: 'conduct-c1-i1', text: 'Punctuality — on-site ready to work at scheduled start, every day' },
        { id: 'conduct-c1-i2', text: 'Uniform & PPE — clean, branded, complete every shift' },
        { id: 'conduct-c1-i3', text: 'Personal cleanliness & grooming standards' },
        { id: 'conduct-c1-i4', text: 'Vehicle, tools, and equipment cleanliness/organization' },
        { id: 'conduct-c1-i5', text: 'Workspace cleanliness (100% Workman — leaves site cleaner than found)' },
      ] },
      { id: 'conduct-c2', name: 'Communication', items: [
        { id: 'conduct-c2-i1', text: 'Verbal communication with supervisors, clients, and crew' },
        { id: 'conduct-c2-i2', text: 'Written communication (texts, emails, daily reports)' },
        { id: 'conduct-c2-i3', text: 'Reporting issues, delays, and safety concerns immediately' },
        { id: 'conduct-c2-i4', text: 'Listening and confirming understanding before acting' },
        { id: 'conduct-c2-i5', text: 'Respectful communication with women, minorities, and clients of all backgrounds' },
      ] },
      { id: 'conduct-c3', name: 'Customer & Stakeholder Behavior', items: [
        { id: 'conduct-c3-i1', text: 'Respect for customer/owner premises and property' },
        { id: 'conduct-c3-i2', text: 'Customer service — courteous, professional, solution-oriented' },
        { id: 'conduct-c3-i3', text: 'Exceeding customer expectations (going above the scope on small things)' },
        { id: 'conduct-c3-i4', text: 'Cordiality and professionalism with subs, suppliers, and inspectors' },
        { id: 'conduct-c3-i5', text: 'Confidentiality — no posting of project info on social media' },
      ] },
      { id: 'conduct-c4', name: 'Team Behavior', items: [
        { id: 'conduct-c4-i1', text: 'Respect for co-workers and crew members' },
        { id: 'conduct-c4-i2', text: 'Conflict de-escalation — no yelling, no profanity at others' },
        { id: 'conduct-c4-i3', text: 'Helping others without being asked' },
        { id: 'conduct-c4-i4', text: 'Accepting feedback without defensiveness' },
        { id: 'conduct-c4-i5', text: 'Owning mistakes — no blame-shifting' },
      ] },
      { id: 'conduct-c5', name: 'Work Ethic & Integrity', items: [
        { id: 'conduct-c5-i1', text: 'Honest time reporting (clock-in/clock-out discipline)' },
        { id: 'conduct-c5-i2', text: 'Honest material usage (no theft, no waste)' },
        { id: 'conduct-c5-i3', text: 'Completed work is up to code AND Diamond Standard' },
        { id: 'conduct-c5-i4', text: 'Refusing shortcuts that compromise quality or safety' },
        { id: 'conduct-c5-i5', text: 'Following the chain of command' },
      ] },
    ] },
  { id: 'safety', short: 'Safety', name: 'Safety & Certifications',
    description: 'Safety is non-negotiable. L2 minimum is required to set foot on any DR jobsite. L3 minimum is required for Tier 2+. Items marked with [CERT] require a current certification — verify on the Employee Profile tab.',
    categories: [
      { id: 'safety-c1', name: 'Foundational Safety', items: [
        { id: 'safety-c1-i1', text: 'OSHA 10 — current', cert: true },
        { id: 'safety-c1-i2', text: 'OSHA 30 — current (required for Foreman+)', cert: true },
        { id: 'safety-c1-i3', text: 'Daily JHA / Pre-task planning' },
        { id: 'safety-c1-i4', text: 'Toolbox talks — attends and contributes' },
        { id: 'safety-c1-i5', text: 'Stop-work authority — knows when and how to use it' },
        { id: 'safety-c1-i6', text: 'Incident reporting protocol' },
        { id: 'safety-c1-i7', text: 'First Aid / CPR', cert: true },
      ] },
      { id: 'safety-c2', name: 'Tools & Equipment Safety', items: [
        { id: 'safety-c2-i1', text: 'Hand tool safety — selection, inspection, use' },
        { id: 'safety-c2-i2', text: 'Power tool safety — guards, GFCI, inspection' },
        { id: 'safety-c2-i3', text: 'Pneumatic tool safety' },
        { id: 'safety-c2-i4', text: 'Powder-actuated tool safety', cert: true },
        { id: 'safety-c2-i5', text: 'Hot work / cutting / welding safety' },
        { id: 'safety-c2-i6', text: 'Truck and trailer safety (loading, securing, towing)' },
      ] },
      { id: 'safety-c3', name: 'Heavy Equipment & Vehicles', items: [
        { id: 'safety-c3-i1', text: 'Forklift operation', cert: true },
        { id: 'safety-c3-i2', text: 'Telehandler operation', cert: true },
        { id: 'safety-c3-i3', text: 'Scissor lift / Boom lift (MEWP) operation', cert: true },
        { id: 'safety-c3-i4', text: 'Skid steer / Backhoe / Excavator operation', cert: true },
        { id: 'safety-c3-i5', text: 'Spotter / signal person duties' },
        { id: 'safety-c3-i6', text: 'Crane signaling basics' },
      ] },
      { id: 'safety-c4', name: 'Hazard-Specific Safety', items: [
        { id: 'safety-c4-i1', text: 'Fall protection — 100% tie-off culture', cp: true },
        { id: 'safety-c4-i2', text: 'Ladder safety — selection, setup, use' },
        { id: 'safety-c4-i3', text: 'Scaffold safety — user level' },
        { id: 'safety-c4-i4', text: 'Scaffold safety — competent person', cp: true },
        { id: 'safety-c4-i5', text: 'Electrical safety / LOTO' },
        { id: 'safety-c4-i6', text: 'Powerline safety / approach distances' },
        { id: 'safety-c4-i7', text: 'Trench & excavation safety', cp: true },
        { id: 'safety-c4-i8', text: 'Confined space entry', cert: true },
        { id: 'safety-c4-i9', text: 'Silica awareness & wet-cut compliance', cert: true },
        { id: 'safety-c4-i10', text: 'Lead / asbestos awareness' },
        { id: 'safety-c4-i11', text: 'Heat stress / cold stress recognition' },
        { id: 'safety-c4-i12', text: 'Eye, ear, respiratory protection — fit testing' },
        { id: 'safety-c4-i13', text: 'Back safety / proper lifting / material handling' },
      ] },
      { id: 'safety-c5', name: 'Emergency & Site-Specific', items: [
        { id: 'safety-c5-i1', text: 'Site-specific orientation discipline (completes for every new site)' },
        { id: 'safety-c5-i2', text: 'Emergency action plan knowledge' },
        { id: 'safety-c5-i3', text: 'Fire extinguisher use' },
        { id: 'safety-c5-i4', text: 'Spill response (oils, fuels, chemicals)' },
        { id: 'safety-c5-i5', text: 'Severe weather protocol' },
      ] },
    ] },
  { id: 'projdisc', short: 'Project Discipline', name: 'Project Discipline',
    description: 'This pillar separates a service tech from a project tradesman. Maintenance work is reactive; project work is plan-driven, sequenced, and documented. This is NEW content not covered by the partner tracker — partner transfers MUST complete the Bridge Module here.',
    categories: [
      { id: 'projdisc-c1', name: 'Plan Reading & Interpretation', items: [
        { id: 'projdisc-c1-i1', text: 'Reading architectural plans (floor plans, elevations, sections)' },
        { id: 'projdisc-c1-i2', text: 'Reading structural plans and details' },
        { id: 'projdisc-c1-i3', text: 'Reading MEP plans (mechanical, electrical, plumbing)' },
        { id: 'projdisc-c1-i4', text: 'Reading civil/site plans' },
        { id: 'projdisc-c1-i5', text: 'Reading shop drawings and submittals' },
        { id: 'projdisc-c1-i6', text: 'Understanding plan symbols, abbreviations, and legends' },
        { id: 'projdisc-c1-i7', text: 'Cross-referencing details across sheets' },
        { id: 'projdisc-c1-i8', text: 'Understanding revisions, addendums, and bulletins' },
      ] },
      { id: 'projdisc-c2', name: 'Measurement & Layout', items: [
        { id: 'projdisc-c2-i1', text: 'Tape measure proficiency — read to 1/16, decimal conversion' },
        { id: 'projdisc-c2-i2', text: 'Use of laser level / rotary laser' },
        { id: 'projdisc-c2-i3', text: 'Use of total station (read-only / hold a stick)' },
        { id: 'projdisc-c2-i4', text: 'Setting control lines and benchmarks' },
        { id: 'projdisc-c2-i5', text: 'Layout from gridlines' },
        { id: 'projdisc-c2-i6', text: 'Squaring (3-4-5, diagonals)' },
        { id: 'projdisc-c2-i7', text: 'Plumb, level, square verification' },
        { id: 'projdisc-c2-i8', text: 'Working with elevations and grade' },
      ] },
      { id: 'projdisc-c3', name: 'Sequencing & Workflow', items: [
        { id: 'projdisc-c3-i1', text: 'Understanding the 11-phase project lifecycle' },
        { id: 'projdisc-c3-i2', text: 'Knowing which trades precede and follow your scope' },
        { id: 'projdisc-c3-i3', text: 'Coordinating handoffs with prior/next trade' },
        { id: 'projdisc-c3-i4', text: 'Working from a 3-week look-ahead schedule' },
        { id: 'projdisc-c3-i5', text: 'Daily plan-of-the-day discipline' },
        { id: 'projdisc-c3-i6', text: 'Identifying schedule risks and reporting up' },
      ] },
      { id: 'projdisc-c4', name: 'Quality Control', items: [
        { id: 'projdisc-c4-i1', text: 'Self-inspection before calling for QC check' },
        { id: 'projdisc-c4-i2', text: 'QC checklist execution per scope' },
        { id: 'projdisc-c4-i3', text: 'Punch list creation and closure discipline' },
        { id: 'projdisc-c4-i4', text: 'Tolerance standards — knows the spec' },
        { id: 'projdisc-c4-i5', text: 'Mock-up / first-piece inspection' },
        { id: 'projdisc-c4-i6', text: 'Owning defects — fix without blame, no concealment' },
      ] },
      { id: 'projdisc-c5', name: 'Documentation & Reporting', items: [
        { id: 'projdisc-c5-i1', text: 'Daily report completion (work performed, headcount, weather, delays)' },
        { id: 'projdisc-c5-i2', text: 'Photo documentation (before, during, after)' },
        { id: 'projdisc-c5-i3', text: 'Time tracking accuracy by cost code' },
        { id: 'projdisc-c5-i4', text: 'Material tracking and waste reporting' },
        { id: 'projdisc-c5-i5', text: 'RFI awareness — knows when to ask' },
        { id: 'projdisc-c5-i6', text: 'Change order awareness — knows what triggers one' },
        { id: 'projdisc-c5-i7', text: 'T&M ticket documentation' },
      ] },
      { id: 'projdisc-c6', name: 'Material & Logistics', items: [
        { id: 'projdisc-c6-i1', text: 'Material takeoff basics for your scope' },
        { id: 'projdisc-c6-i2', text: 'Material receiving and inspection' },
        { id: 'projdisc-c6-i3', text: 'Just-in-time vs stockpile decisions' },
        { id: 'projdisc-c6-i4', text: 'Material protection on site' },
        { id: 'projdisc-c6-i5', text: 'Waste segregation and recycling compliance' },
      ] },
    ] },
  { id: 'digital', short: 'Digital & BIM', name: 'Digital & BIM Literacy',
    description: 'Diamond Ridge runs a BIM-integrated platform. Every tradesman must be digitally literate. L2 minimum is required for Tier 2. L3 is required for Foreman track. This is NEW content not covered by the partner tracker.',
    categories: [
      { id: 'digital-c1', name: 'Core Digital Literacy', items: [
        { id: 'digital-c1-i1', text: 'Smartphone proficiency for work apps' },
        { id: 'digital-c1-i2', text: 'Email use — checks daily, responds appropriately' },
        { id: 'digital-c1-i3', text: 'Photo capture, naming, and upload discipline' },
        { id: 'digital-c1-i4', text: 'Cloud file access (Google Drive / SharePoint / OneDrive)' },
        { id: 'digital-c1-i5', text: 'Basic Excel — reading a schedule, filling a checklist' },
        { id: 'digital-c1-i6', text: 'Basic data entry without errors' },
      ] },
      { id: 'digital-c2', name: 'Construction Management Platforms', items: [
        { id: 'digital-c2-i1', text: 'Autodesk Construction Cloud (ACC) — viewing plans on a tablet' },
        { id: 'digital-c2-i2', text: 'ACC — uploading photos, marking up issues' },
        { id: 'digital-c2-i3', text: 'ACC — pulling latest revision, identifying revision clouds' },
        { id: 'digital-c2-i4', text: 'Procore / equivalent (if applicable) — daily reports' },
        { id: 'digital-c2-i5', text: 'Time clock / payroll app proficiency' },
      ] },
      { id: 'digital-c3', name: 'BIM Awareness', items: [
        { id: 'digital-c3-i1', text: 'Understanding what BIM is and why DR uses it' },
        { id: 'digital-c3-i2', text: 'Reading a Revit model on a tablet (rotate, pan, section)' },
        { id: 'digital-c3-i3', text: 'Identifying conflicts/clashes vs as-installed' },
        { id: 'digital-c3-i4', text: 'Reading clash detection reports from BIM coordinator' },
        { id: 'digital-c3-i5', text: 'Reporting field conditions back to BIM team' },
        { id: 'digital-c3-i6', text: 'Tandem / digital twin awareness for FM handoff' },
      ] },
      { id: 'digital-c4', name: 'Markup & Estimating Tools', items: [
        { id: 'digital-c4-i1', text: 'Bluebeam — opening, navigating, basic markup' },
        { id: 'digital-c4-i2', text: 'Bluebeam — measurement tools, takeoff awareness' },
        { id: 'digital-c4-i3', text: 'RSMeans / Xactimate awareness (for senior tradesmen)' },
      ] },
      { id: 'digital-c5', name: 'Data Discipline', items: [
        { id: 'digital-c5-i1', text: 'Naming conventions for photos and files' },
        { id: 'digital-c5-i2', text: 'Tagging photos to location/cost code' },
        { id: 'digital-c5-i3', text: 'Confidentiality of project data' },
        { id: 'digital-c5-i4', text: 'AI tool usage policy compliance' },
      ] },
    ] },
  { id: 'trade', short: 'Trade Skills', name: 'Trade Technical Skills',
    description: 'Trade-specific technical competencies. This expands the partner tracker by adding commercial / project-scale tasks. A tradesman is rated only on trades they actively perform. Tier 2+ requires L3 in at least 2 categories; Tier 3 requires L3 in 4+ categories.',
    categories: [
      { id: 'trade-c1', name: 'Tools & Materials (General)', items: [
        { id: 'trade-c1-i1', text: 'Tool list — owns, maintains, knows uses' },
        { id: 'trade-c1-i2', text: 'Identify truck/job materials by sight and spec' },
        { id: 'trade-c1-i3', text: 'Reading material spec sheets and submittals' },
      ] },
      { id: 'trade-c2', name: 'Framing', items: [
        { id: 'trade-c2-i1', text: 'Floor framing — joists, rim, blocking' },
        { id: 'trade-c2-i2', text: 'Exterior wall framing — plates, studs, headers' },
        { id: 'trade-c2-i3', text: 'Interior wall framing' },
        { id: 'trade-c2-i4', text: 'Roof framing — rafters, trusses, sheathing' },
        { id: 'trade-c2-i5', text: 'Structural framing — engineered lumber (LVL, PSL, glulam)' },
        { id: 'trade-c2-i6', text: 'Stair framing — stringers, treads, code-compliant rise/run' },
        { id: 'trade-c2-i7', text: 'Steel stud framing — track, studs, drywall vs structural' },
        { id: 'trade-c2-i8', text: 'Shear wall / hold-down installation per detail' },
        { id: 'trade-c2-i9', text: 'Backing for fixtures, cabinets, equipment' },
      ] },
      { id: 'trade-c3', name: 'Drywall', items: [
        { id: 'trade-c3-i1', text: 'Identifying drywall types, tools, materials' },
        { id: 'trade-c3-i2', text: 'Hanging drywall — walls and ceilings' },
        { id: 'trade-c3-i3', text: 'Fastening to code and spec' },
        { id: 'trade-c3-i4', text: 'Drywall backing for accessories' },
        { id: 'trade-c3-i5', text: 'Finishing with hand tools (Levels 1-5 finish)' },
        { id: 'trade-c3-i6', text: 'Finishing with automatic tools (Ames/Tape Tech)' },
        { id: 'trade-c3-i7', text: 'Drywall patching — small and large' },
        { id: 'trade-c3-i8', text: 'Fire-rated assemblies — installation per UL listing' },
      ] },
      { id: 'trade-c4', name: 'Electrical', items: [
        { id: 'trade-c4-i1', text: 'Residential electrical process' },
        { id: 'trade-c4-i2', text: 'Wire connections — wire nuts, lugs, terminations' },
        { id: 'trade-c4-i3', text: 'Mounting boxes — depth, alignment, support' },
        { id: 'trade-c4-i4', text: 'Sizing and running Romex' },
        { id: 'trade-c4-i5', text: 'Running MC / AC cable' },
        { id: 'trade-c4-i6', text: 'EMT bending and installation' },
        { id: 'trade-c4-i7', text: 'Receptacles, switches, dimmers' },
        { id: 'trade-c4-i8', text: 'GFCI, AFCI, dual-function devices' },
        { id: 'trade-c4-i9', text: '3-way and 4-way switching' },
        { id: 'trade-c4-i10', text: 'Fan brackets and pre-wire' },
        { id: 'trade-c4-i11', text: 'Photo cells, timers, occupancy sensors' },
        { id: 'trade-c4-i12', text: 'Fluorescent and LED lighting' },
        { id: 'trade-c4-i13', text: 'Service entrance — residential' },
        { id: 'trade-c4-i14', text: 'Sub panels — installation and labeling' },
        { id: 'trade-c4-i15', text: 'Disconnect sizing and installation' },
        { id: 'trade-c4-i16', text: '220V wiring — appliances, equipment' },
        { id: 'trade-c4-i17', text: 'Wire sizing per NEC' },
        { id: 'trade-c4-i18', text: 'NEC fundamentals — knows the code book' },
        { id: 'trade-c4-i19', text: 'Troubleshooting — meter use, fault isolation' },
        { id: 'trade-c4-i20', text: 'Low-voltage / data / coax pulls' },
        { id: 'trade-c4-i21', text: 'Fire alarm and life safety basics (commercial)' },
      ] },
      { id: 'trade-c5', name: 'Plumbing', items: [
        { id: 'trade-c5-i1', text: 'Aerator, sprayer, shower head cleaning' },
        { id: 'trade-c5-i2', text: 'Faucet repair and replacement' },
        { id: 'trade-c5-i3', text: 'Hose bib repair and replacement' },
        { id: 'trade-c5-i4', text: 'Faucet installation — kitchen, bath, tub/shower' },
        { id: 'trade-c5-i5', text: 'Shut-off valves' },
        { id: 'trade-c5-i6', text: 'Sink repair and replacement' },
        { id: 'trade-c5-i7', text: 'Pop-up drains, P-traps, strainers' },
        { id: 'trade-c5-i8', text: 'Garbage disposal — install and unplug' },
        { id: 'trade-c5-i9', text: 'Toilet — remove, replace, flange, wax ring' },
        { id: 'trade-c5-i10', text: 'Toilet — flapper, fill valve, supply line' },
        { id: 'trade-c5-i11', text: 'Water heater — install, code compliance' },
        { id: 'trade-c5-i12', text: 'Water heater — maintenance, troubleshooting' },
        { id: 'trade-c5-i13', text: 'Tub install / shower base / pan liner' },
        { id: 'trade-c5-i14', text: 'Tub drain and overflow' },
        { id: 'trade-c5-i15', text: 'Caulking and silicone — wet-area discipline' },
        { id: 'trade-c5-i16', text: 'Copper water lines — solder, press fit' },
        { id: 'trade-c5-i17', text: 'PEX water lines — A vs B, expansion vs crimp' },
        { id: 'trade-c5-i18', text: 'Threaded steel — black and galvanized' },
        { id: 'trade-c5-i19', text: 'PVC / CPVC water lines' },
        { id: 'trade-c5-i20', text: 'Sizing water lines — fixture units' },
        { id: 'trade-c5-i21', text: 'Shut-off valves and water meter' },
        { id: 'trade-c5-i22', text: 'Drain & vent system — design understanding' },
        { id: 'trade-c5-i23', text: 'ABS and PVC drain installation' },
        { id: 'trade-c5-i24', text: 'Cast iron drain — no-hub, leaded' },
        { id: 'trade-c5-i25', text: 'Sizing drain lines and venting' },
        { id: 'trade-c5-i26', text: 'Backflow prevention awareness' },
      ] },
      { id: 'trade-c6', name: 'Rooter / Drain Cleaning', items: [
        { id: 'trade-c6-i1', text: 'Toilet rootering' },
        { id: 'trade-c6-i2', text: 'Tub drain rootering' },
        { id: 'trade-c6-i3', text: 'Sink drain rootering' },
        { id: 'trade-c6-i4', text: 'Floor drain rootering' },
        { id: 'trade-c6-i5', text: 'Main line rootering' },
        { id: 'trade-c6-i6', text: 'Camera snake and line location' },
        { id: 'trade-c6-i7', text: 'Hydro-jet awareness' },
      ] },
      { id: 'trade-c7', name: 'HVAC', items: [
        { id: 'trade-c7-i1', text: 'Swamp cooler — install, maintain, summerize, winterize' },
        { id: 'trade-c7-i2', text: 'Swamp cooler — troubleshoot and replace' },
        { id: 'trade-c7-i3', text: 'Forced air furnace — install' },
        { id: 'trade-c7-i4', text: 'Furnace tune-up' },
        { id: 'trade-c7-i5', text: 'Blower motor replacement' },
        { id: 'trade-c7-i6', text: 'Inducer motor replacement' },
        { id: 'trade-c7-i7', text: 'Gas valve (electronic) replacement' },
        { id: 'trade-c7-i8', text: 'Furnace control board replacement' },
        { id: 'trade-c7-i9', text: 'Black pipe gas lines' },
        { id: 'trade-c7-i10', text: 'Flexible gas lines (CSST)' },
        { id: 'trade-c7-i11', text: 'Central AC — controls, condenser fan, compressor' },
        { id: 'trade-c7-i12', text: 'Refrigerant leak detection and repair (EPA 608)' },
        { id: 'trade-c7-i13', text: 'Recharging AC systems (EPA 608)' },
        { id: 'trade-c7-i14', text: 'RTU (rooftop unit) replacement' },
        { id: 'trade-c7-i15', text: 'Mini-split — install, troubleshoot, repair' },
        { id: 'trade-c7-i16', text: 'Commercial HVAC maintenance' },
        { id: 'trade-c7-i17', text: 'Duct and vent sizing' },
        { id: 'trade-c7-i18', text: 'Equipment sizing (Manual J/D awareness)' },
        { id: 'trade-c7-i19', text: 'Test and balance basics' },
      ] },
      { id: 'trade-c8', name: 'Roofing', items: [
        { id: 'trade-c8-i1', text: 'Roofing identification — asphalt, metal, TPO, EPDM, modified bit' },
        { id: 'trade-c8-i2', text: 'Flashing and attic venting' },
        { id: 'trade-c8-i3', text: 'Asphalt shingle install — full system' },
        { id: 'trade-c8-i4', text: 'Asphalt shingle repair' },
        { id: 'trade-c8-i5', text: 'Underlayment systems — ice/water, synthetic' },
        { id: 'trade-c8-i6', text: 'Metal roofing — standing seam basics' },
        { id: 'trade-c8-i7', text: 'TPO / EPDM membrane repair' },
        { id: 'trade-c8-i8', text: 'TPO / EPDM membrane install (commercial)' },
        { id: 'trade-c8-i9', text: 'Penetration detailing and curbs' },
        { id: 'trade-c8-i10', text: 'Manufacturer warranty compliance' },
      ] },
      { id: 'trade-c9', name: 'Flooring / Tile', items: [
        { id: 'trade-c9-i1', text: 'Tools and materials identification' },
        { id: 'trade-c9-i2', text: 'Substrate prep and moisture testing' },
        { id: 'trade-c9-i3', text: 'Carpet — remove, install, seam' },
        { id: 'trade-c9-i4', text: 'Tack strip and pad' },
        { id: 'trade-c9-i5', text: 'Laminate flooring' },
        { id: 'trade-c9-i6', text: 'Vinyl flooring — sheet and LVP' },
        { id: 'trade-c9-i7', text: 'Vinyl seaming' },
        { id: 'trade-c9-i8', text: 'Tile — set wall and floor' },
        { id: 'trade-c9-i9', text: 'Durarock / mesh and float' },
        { id: 'trade-c9-i10', text: 'Tile grouting and sealing' },
        { id: 'trade-c9-i11', text: 'Large format tile — leveling system' },
        { id: 'trade-c9-i12', text: 'Hardwood — nail down, glue down, floating' },
        { id: 'trade-c9-i13', text: 'Transitions and trim' },
      ] },
      { id: 'trade-c10', name: 'Carpentry, Cabinets, Counters', items: [
        { id: 'trade-c10-i1', text: 'Interior door install and repair' },
        { id: 'trade-c10-i2', text: 'Wood trim — base, casing, jambs' },
        { id: 'trade-c10-i3', text: 'Closet shelving' },
        { id: 'trade-c10-i4', text: 'Crown molding and advanced trim' },
        { id: 'trade-c10-i5', text: 'Stain-grade trim' },
        { id: 'trade-c10-i6', text: 'Stairs and railings (code-compliant)' },
        { id: 'trade-c10-i7', text: 'Reading a cabinet blueprint' },
        { id: 'trade-c10-i8', text: 'Cabinet install — uppers, lowers, fillers' },
        { id: 'trade-c10-i9', text: 'Countertops — laminate, solid surface, stone awareness' },
      ] },
      { id: 'trade-c11', name: 'Doors & Windows', items: [
        { id: 'trade-c11-i1', text: 'Tools and materials — doors' },
        { id: 'trade-c11-i2', text: 'Interior door install' },
        { id: 'trade-c11-i3', text: 'Exterior door install' },
        { id: 'trade-c11-i4', text: 'French door / sidelight install' },
        { id: 'trade-c11-i5', text: 'Sliding glass door install' },
        { id: 'trade-c11-i6', text: 'Door slab replacement' },
        { id: 'trade-c11-i7', text: 'Threshold and weatherseal' },
        { id: 'trade-c11-i8', text: 'Commercial steel door on steel jamb' },
        { id: 'trade-c11-i9', text: 'Door closers, stops, hardware' },
        { id: 'trade-c11-i10', text: 'Tools and materials — windows' },
        { id: 'trade-c11-i11', text: 'Vinyl window install — new construction' },
        { id: 'trade-c11-i12', text: 'Vinyl window — retrofit replacement' },
        { id: 'trade-c11-i13', text: 'Glass pane replacement' },
        { id: 'trade-c11-i14', text: 'Storm door install' },
      ] },
      { id: 'trade-c12', name: 'Painting & Finishes', items: [
        { id: 'trade-c12-i1', text: 'Painting tools and materials' },
        { id: 'trade-c12-i2', text: 'Surface prep — scrape, sand, prime' },
        { id: 'trade-c12-i3', text: 'Brush work — cutting in' },
        { id: 'trade-c12-i4', text: 'Roller work — walls, ceilings' },
        { id: 'trade-c12-i5', text: 'Spray application' },
        { id: 'trade-c12-i6', text: 'Cleanup and touch-up' },
        { id: 'trade-c12-i7', text: 'Matching paint and stains' },
        { id: 'trade-c12-i8', text: 'Staining and lacquer finishes' },
        { id: 'trade-c12-i9', text: 'Wall covering / wall paper' },
        { id: 'trade-c12-i10', text: 'Patch painting and texture matching' },
      ] },
      { id: 'trade-c13', name: 'Sprinklers / Irrigation', items: [
        { id: 'trade-c13-i1', text: 'Tools and materials' },
        { id: 'trade-c13-i2', text: 'Summerize and winterize' },
        { id: 'trade-c13-i3', text: 'System operation understanding' },
        { id: 'trade-c13-i4', text: 'Timer test, repair, replace' },
        { id: 'trade-c13-i5', text: 'Splicing timer wire' },
        { id: 'trade-c13-i6', text: 'Valve test, repair, replace' },
        { id: 'trade-c13-i7', text: 'Head and tip test, repair, replace' },
        { id: 'trade-c13-i8', text: 'Stop and waste install and replace' },
        { id: 'trade-c13-i9', text: 'PVC pipe install and repair' },
        { id: 'trade-c13-i10', text: 'Troubleshooting' },
        { id: 'trade-c13-i11', text: 'System design and new install' },
      ] },
      { id: 'trade-c14', name: 'Landscaping', items: [
        { id: 'trade-c14-i1', text: 'Lawn maintenance tools and equipment' },
        { id: 'trade-c14-i2', text: 'Mowing, edging, weed-whacking' },
        { id: 'trade-c14-i3', text: 'Hedging, tree trimming, pruning' },
        { id: 'trade-c14-i4', text: 'Fertilizing and weed spray' },
        { id: 'trade-c14-i5', text: 'Weeding flower beds' },
        { id: 'trade-c14-i6', text: 'Soil amendment' },
        { id: 'trade-c14-i7', text: 'Sod prep and install' },
        { id: 'trade-c14-i8', text: 'Planting trees, shrubs, flowers' },
      ] },
      { id: 'trade-c15', name: 'Fencing', items: [
        { id: 'trade-c15-i1', text: 'Chainlink — full install and stretch' },
        { id: 'trade-c15-i2', text: 'Chainlink — gates and repairs' },
        { id: 'trade-c15-i3', text: 'Wood fence install and repair' },
        { id: 'trade-c15-i4', text: 'Wood fence staining' },
        { id: 'trade-c15-i5', text: 'Wood gate install and repair' },
        { id: 'trade-c15-i6', text: 'Vinyl fence install and repair' },
      ] },
      { id: 'trade-c16', name: 'Exterior Finishes', items: [
        { id: 'trade-c16-i1', text: 'Siding install and repair (hardie, vinyl, wood)' },
        { id: 'trade-c16-i2', text: 'Soffit and fascia' },
        { id: 'trade-c16-i3', text: 'Stucco repair' },
      ] },
      { id: 'trade-c17', name: 'Concrete & Masonry', items: [
        { id: 'trade-c17-i1', text: 'Concrete cutting (silica-compliant)' },
        { id: 'trade-c17-i2', text: 'Concrete removal' },
        { id: 'trade-c17-i3', text: 'Flatwork install' },
        { id: 'trade-c17-i4', text: 'Footings and foundations' },
        { id: 'trade-c17-i5', text: 'Concrete patching' },
        { id: 'trade-c17-i6', text: 'Masonry repair' },
        { id: 'trade-c17-i7', text: 'Masonry install' },
      ] },
      { id: 'trade-c18', name: 'Demo & Excavation', items: [
        { id: 'trade-c18-i1', text: 'Blue Stakes / 811 protocol' },
        { id: 'trade-c18-i2', text: 'Utility identification' },
        { id: 'trade-c18-i3', text: 'Structural identification' },
        { id: 'trade-c18-i4', text: 'Backhoe / mini-ex operation' },
        { id: 'trade-c18-i5', text: 'Hand digging' },
        { id: 'trade-c18-i6', text: 'Compaction and lifts' },
        { id: 'trade-c18-i7', text: 'Barricading and traffic control' },
      ] },
      { id: 'trade-c19', name: 'Insulation', items: [
        { id: 'trade-c19-i1', text: 'Identification and pros/cons' },
        { id: 'trade-c19-i2', text: 'R-value understanding' },
        { id: 'trade-c19-i3', text: 'Fiberglass batts' },
        { id: 'trade-c19-i4', text: 'Blown-in insulation' },
        { id: 'trade-c19-i5', text: 'Spray foam (polyurethane) awareness' },
        { id: 'trade-c19-i6', text: 'Vapor barriers and air sealing' },
      ] },
      { id: 'trade-c20', name: 'Paperwork & Office (per scope)', items: [
        { id: 'trade-c20-i1', text: 'Daily review sheet' },
        { id: 'trade-c20-i2', text: 'Entering packets' },
        { id: 'trade-c20-i3', text: 'Entering invoices' },
        { id: 'trade-c20-i4', text: 'Material tracking' },
        { id: 'trade-c20-i5', text: 'Apprentice / journeyman / lead checklists' },
        { id: 'trade-c20-i6', text: 'Bidding small jobs' },
      ] },
    ] },
  { id: 'leadership', short: 'Leadership', name: 'Leadership & Development',
    description: 'Leadership is required for Foreman (L4) and Trainer (L5). Required minimum is L3 in Pillars 1-3 AND L3 in primary trade before any leadership tier is awarded. This is NEW content not covered by the partner tracker.',
    categories: [
      { id: 'leadership-c1', name: 'Crew Leadership', items: [
        { id: 'leadership-c1-i1', text: 'Running a 2-person crew' },
        { id: 'leadership-c1-i2', text: 'Running a 3-5 person crew' },
        { id: 'leadership-c1-i3', text: 'Running a 5+ person crew or multiple crews' },
        { id: 'leadership-c1-i4', text: 'Daily plan-of-the-day execution' },
        { id: 'leadership-c1-i5', text: 'Assigning work to crew members appropriately' },
        { id: 'leadership-c1-i6', text: 'Holding crew accountable to Diamond Standard' },
        { id: 'leadership-c1-i7', text: 'Managing crew morale and conflict' },
      ] },
      { id: 'leadership-c2', name: 'Project Coordination', items: [
        { id: 'leadership-c2-i1', text: 'Coordinating with other trade foremen' },
        { id: 'leadership-c2-i2', text: 'Reporting up to superintendent / PM' },
        { id: 'leadership-c2-i3', text: 'Participating in subcontractor meetings' },
        { id: 'leadership-c2-i4', text: 'Managing material deliveries and storage' },
        { id: 'leadership-c2-i5', text: 'Schedule input — look-ahead participation' },
        { id: 'leadership-c2-i6', text: 'Owning a punch list to closeout' },
      ] },
      { id: 'leadership-c3', name: 'Quality & Safety Ownership', items: [
        { id: 'leadership-c3-i1', text: 'Pre-task plan / JHA leadership' },
        { id: 'leadership-c3-i2', text: 'Toolbox talk delivery' },
        { id: 'leadership-c3-i3', text: 'QC self-audit and reporting' },
        { id: 'leadership-c3-i4', text: 'Stop-work decisions and escalation' },
        { id: 'leadership-c3-i5', text: 'Incident investigation participation' },
        { id: 'leadership-c3-i6', text: 'Near-miss reporting and culture' },
      ] },
      { id: 'leadership-c4', name: 'People Development', items: [
        { id: 'leadership-c4-i1', text: 'Onboarding a new hire to a crew' },
        { id: 'leadership-c4-i2', text: 'Teaching a skill at L1 (Exposure) level' },
        { id: 'leadership-c4-i3', text: 'Teaching a skill at L2 (Competency) level' },
        { id: 'leadership-c4-i4', text: 'Coaching to L3 (Mastery)' },
        { id: 'leadership-c4-i5', text: 'Conducting skills sign-offs on this tracker' },
        { id: 'leadership-c4-i6', text: 'Identifying and recommending promotion candidates' },
        { id: 'leadership-c4-i7', text: 'Identifying and addressing performance issues' },
      ] },
      { id: 'leadership-c5', name: 'Business Awareness', items: [
        { id: 'leadership-c5-i1', text: 'Understanding cost codes and budgets' },
        { id: 'leadership-c5-i2', text: 'Awareness of project P&L impact' },
        { id: 'leadership-c5-i3', text: 'Knowing when a change order is needed' },
        { id: 'leadership-c5-i4', text: 'Knowing when an RFI is needed' },
        { id: 'leadership-c5-i5', text: 'Customer / owner interaction at a foreman level' },
        { id: 'leadership-c5-i6', text: 'Representing Diamond Ridge professionally to outsiders' },
      ] },
    ] },
];

